import { useLanguage } from '../context/LanguageContext.js';
export default function OurProjects(props){
    const { language} = useLanguage();
    return <div className="project-container2" style={{direction:language==="en"&&"ltr"}}>
<div className="project-img-div">
<img src={props.data.img} alt="projectImage"/>
</div>
<div className="project-description-div">
<h4>{props.data.title}</h4>
<p>{props.data.description}</p>
</div>
    </div>
}